/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from ".";

// Fetch orders
export const fetchOrders = async (data) => {
  const response = await api.get("/v1/admin/orders", {
    params: { ...data, per_page: 1000000 },
  });
  return response?.data;
};

// Fetch columns list
export const fetchColumns = async (data) => {
  const response = await api.get("/v1/admin/column_settings", { params: data });
  return response?.data;
};

// Fetch columns list
export const updateColumns = async (data) => {
  const response = await api.post(
    "/v1/admin/column_settings/update_hidden_columns",
    data
  );
  return response?.data;
};

export const fetchOrdersDailyData = async () => {
  const response = await api.post(`/v1/admin/orders/fetch_orders`, {});
  return response?.data;
};

export const uploadFile = async (formData) => {
  const response = await api.post(
    "/v1/admin/orders/import_orders_data",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response?.data;
};
